var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFtLi(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.898438 18.6506C0.898438 8.40519 9.20402 0.0996094 19.4495 0.0996094C29.6949 0.0996094 38.0005 8.40519 38.0005 18.6506C38.0005 28.8961 29.6949 37.2017 19.4495 37.2017C9.20402 37.2017 0.898438 28.8961 0.898438 18.6506ZM14.0077 15.4642H9.80359V28.0957H14.0077V15.4642ZM14.2848 11.5567C14.2575 10.3182 13.3718 9.37488 11.9337 9.37488C10.4955 9.37488 9.55524 10.3182 9.55524 11.5567C9.55524 12.7696 10.4677 13.74 11.8791 13.74H11.906C13.3718 13.74 14.2848 12.7696 14.2848 11.5567ZM29.1689 20.8531C29.1689 16.9733 27.0949 15.1675 24.3285 15.1675C22.0964 15.1675 21.097 16.3936 20.5391 17.2536V15.4645H16.3345C16.3899 16.6498 16.3345 28.096 16.3345 28.096H20.5391V21.0415C20.5391 20.664 20.5663 20.2874 20.6775 20.0171C20.9813 19.2629 21.6732 18.4821 22.8346 18.4821C24.3565 18.4821 24.9649 19.6404 24.9649 21.3378V28.0956H29.1688L29.1689 20.8531Z",
    className: "icon-primary-color"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFtLi);
export default __webpack_public_path__ + "static/media/icon-ft-li.95063fd6090a8756214b28193147bfa5.svg";
export { ForwardRef as ReactComponent };